import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import { useApiFetch } from "../utils/apiFetch";

function EliminarBienes() {
    const { bienSeleccionado, setModuloActual, setSubModuloActual, logout, enlaceInformatico } = useGlobal();
    const [serieBien, setSerieBien] = useState("");
    const [datosBien, setDatosBien] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const apiFetch = useApiFetch();

    // Cuando se viene desde ConsultarBienes.jsx y ya hay bienSeleccionado se carga directo
    useEffect(() => {
        if (bienSeleccionado) {
            const cargarBien = async () => {
                try {
                    const data = await apiFetch("consulta_20.php", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ serie_bien: bienSeleccionado })
                    }, logout);

                    if (data.status === "ok" && data.bien) {
                        setDatosBien(data.bien);
                    } else {
                        setError(data.message || "Bien no encontrado.");
                    }
                } catch {
                    setError("Error al cargar bien.");
                }
            };

            cargarBien();
        }
    }, [bienSeleccionado]);

    // Cuando hay que buscar el bien manualmente y no viene de  ConsultarBienes.jsx
    const handleBuscar = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setLoading(true);

        try {
            const data = await apiFetch("consulta_20.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ serie_bien: serieBien })
            }, logout);

            if (data.status === "ok" && data.bien) {
                setDatosBien(data.bien);
            } else {
                setError(data.message || "Bien no encontrado.");
            }
        } catch (err) {
            setError("Error de conexión con el servidor.");
        } finally {
            setLoading(false);
        }
    };

    // Eliminar bien
    const handleEliminar = async () => {
        setError("");
        setSuccess("");
        setLoading(true);

        try {

            const data = await apiFetch("eliminar_bienes.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    serie_bien: bienSeleccionado || serieBien,
                    id_resg: enlaceInformatico,
                    id_uso: enlaceInformatico
                })
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Bien eliminado correctamente.");
            } else {
                setError(data.message || "Error al eliminar bien.");
            }

            setTimeout(() => {
                setModuloActual("Hardware");
                setSubModuloActual(null);
                setLoading(false);
            }, 3000);

        } catch (err) {
            setError("Error de conexión con el servidor.");
            setTimeout(() => {
                setModuloActual("Hardware");
                setSubModuloActual(null);
                setLoading(false);
            }, 3000);
        }
    };

    // Cancelar eliminación
    const handleCancelar = () => {
        // Limpia mensajes y estados
        setError("");
        setSuccess("");
        setDatosBien(null);

        setModuloActual("Hardware");
        setSubModuloActual("Consultar Bienes");
    };

    return (
        <div className="sesion-form">

            {error && <div className="error">{error}</div>}
            {success && <div className="success">{success}</div>}

            {/* Mostrar formulario inicial solo si no hay bienSeleccionado */}
            {!datosBien && !bienSeleccionado && (
                <form onSubmit={handleBuscar}>

                    <InputGenerico
                        value={serieBien}
                        setValue={setSerieBien}
                        label="Serie del bien a eliminar"
                        maxLength={30}
                        allowedChars="A-Z0-9_\\-"
                        transform="uppercase"
                        placeholder="MXL1234ABC"
                    />

                    {error && <div className="error">{error}</div>}
                    {success && <div className="success">{success}</div>}
                    <div className="form-buttons">
                        <button type="submit" disabled={loading}>
                            {loading ? "Buscando..." : "Buscar"}
                        </button>
                    </div>
                </form>
            )}

            {datosBien && (
                <div>
                    <p>
                        ¿Seguro que deseas eliminar el bien con serie <strong>{datosBien.serie_bien}</strong>,
                        marca <strong>{datosBien.marca}</strong>, modelo <strong>{datosBien.modelo}</strong>,
                        usuario <strong>{`${datosBien.a_paterno} ${datosBien.a_materno} ${datosBien.usuario}`}</strong>,
                        e IP <strong>{datosBien.ip || "N/A"}</strong>?
                    </p>

                    <div className="form-buttons">
                        <button onClick={handleEliminar} disabled={loading}>
                            {loading ? "Eliminando..." : "Eliminar"}
                        </button>
                        <button onClick={handleCancelar} disabled={loading}>
                            Cancelar
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default EliminarBienes;